import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { reset } from 'redux-form';
import Filter from './Filter';
import { financialReport, loadSchoolYears, FINANCIAL_REPORT_REQUEST, FINANCIAL_REPORT_SUCCESS, FINANCIAL_REPORT_FAILURE } from './actions';
import utils from '../../../common/services/utils';
import { saveAs } from 'file-saver';
import ReduxBlockUi from 'react-block-ui/redux';

class FinancialReport extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
	}

	componentDidMount() {
		const { currentYear, loadSchoolYears } = this.props;

		loadSchoolYears();
		const filter = { year: currentYear};		
	}
	
	saveFile(response, year) {
		saveAs(response, `FinancialReport-${year}.xlsx`);
	}

	handleFilterSubmit(values) {
		const { financialReport } = this.props;
		const filter = { year: values.year, centerId: values.centerId };

		const onSuccess = (response) => this.saveFile(response, values.year);
		financialReport(filter, onSuccess);
	}

	render() {
		const { data, years, currentYear } = this.props;

		return (
			<div>
				<ReduxBlockUi block={FINANCIAL_REPORT_REQUEST} unblock={[FINANCIAL_REPORT_SUCCESS, FINANCIAL_REPORT_FAILURE]}>
					<Filter
						onSubmit={this.handleFilterSubmit}
						years={years}
						initialValues={{ year: currentYear }}
					/>					
				</ReduxBlockUi>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	
	const {
		pagination,
		entities: { financialReport, schoolYears }
	} = state;
	
	
	return {
		years: schoolYears,
		currentYear: utils.getCurrentSchoolYear()
	};
};

const mapDispatchToProps = {
	loadSchoolYears,
	financialReport,
	resetFilter: () => reset('financialReportFilter')
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FinancialReport));